function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#8f006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4c00b3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#c8006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8200b3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#c8006d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c5009f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0.5,
  y1: -0.078,
  x2: 0.5,
  y2: 1.101,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#ff3067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff009f"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "AdCreative",
  transform: "translate(-325.966 -161.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4851",
  "data-name": "Group 4851",
  transform: "translate(325.966 161.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4851-2",
  "data-name": "Group 4851",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3567",
  "data-name": "Path 3567",
  d: "M321.545,535.336,301.667,545.8a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,521.3,321.5,532.341A1.68,1.68,0,0,1,321.545,535.336Z",
  transform: "translate(-275.322 -501.739)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3568",
  "data-name": "Path 3568",
  d: "M321.545,422.535,301.667,433a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3L298.882,408.5,321.5,419.54A1.68,1.68,0,0,1,321.545,422.535Z",
  transform: "translate(-275.322 -395.709)",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3569",
  "data-name": "Path 3569",
  d: "M321.545,310.365l-19.878,10.465a5.978,5.978,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l22.617-11.044L321.5,307.369A1.68,1.68,0,0,1,321.545,310.365Z",
  transform: "translate(-275.322 -290.271)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3570",
  "data-name": "Path 3570",
  d: "M321.545,208.824l-19.878,10.465a5.979,5.979,0,0,1-5.57,0l-19.878-10.465a1.68,1.68,0,0,1,.045-3l19.994-9.763a5.979,5.979,0,0,1,5.247,0l19.994,9.763A1.68,1.68,0,0,1,321.545,208.824Z",
  transform: "translate(-275.322 -195.459)",
  fill: "url(#linear-gradient-4)"
}))));

function SvgLogowithouttext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.12,
    height: 36.75,
    className: "logo-without-text-icon-svg",
    viewBox: "0 0 47.12 44.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowithouttext);
export default __webpack_public_path__ + "static/media/logowithouttext.dbdd9730.svg";
export { ForwardRef as ReactComponent };